const _ = require('underscore');
const MemberCollection = require('common/domain/collection/member');
const License = require('common/domain/entity/license');
const i18n = require('i18next');
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した GroupModel を定義する
     */
    defaults: {
        name: '',
        image_blob: null,
        image_url: null,
        description: '',
        invitation_mail_addresses: [],
        members: []
    },

    validation: function(){
        return {
            name: {
                required: true,
                msg: i18n.t('validation:required')
            }
        }
    },

    initialize: function() {
        this._members = new MemberCollection();
        this._membersWithSuspended = new MemberCollection();
        this._updateMembers();
        this.listenTo(this, 'change:members', this._updateMembers);

        this._updateLicenses();
        this.listenTo(this, 'change:licenses', this._updateLicenses);
    },

    _updateMembers: function() {
        this._membersWithSuspended.add(this.get('members'), {merge: true});
        this._members.set(
            this._membersWithSuspended.filter(m => !m.isSuspended()), {merge: true});
    },

    _updateLicenses: function() {
        this._licenses = new Backbone.Collection(this.get('licenses'), {model: License});
    },

    idParams: function() {
        var params = {
            group_id: this.get('id')
        };
        return params;
    },

    path: function() {
        return `/groups/${this.id}`;
    },

    getImageURL: function() {
        return this.get('image_url');
    },

    /**
     * active: Dashboard 画面内で選択中か否かを判別するフラグ
     * activate: active フラグに true を設定し、 'change:choose' イベントを発火する
     * deactivate: active フラグに false を設定し、 'change:choose' イベントを発火する
     */
    active: false,
    activate: function() {
        this.active = true;
        this.trigger('change:choose', this);
        return this;
    },
    deactivate: function() {
        this.active = false;
        this.trigger('change:choose', this);
        return this;
    },

    /**
     * User or User IDを渡して、その User が Group の管理者か否かを判定します。
     *
     * Group Admin の場合は true を、
     * Group Member の場合は false を、
     * Group Member でない場合は null を返します。
     *
     * またユーザーが利用停止中の場合は常に false が帰ります。
     *
     * @param user
     * @returns {*}
     */
    isAdmin: function(user) {
        const member = this._members.getMemberByUser(user);
        if(!member) {
            return null;
        }

        if (member.isSuspended()) {
            return false;
        }

        return member.isAdmin();
    },

    /**
     * User or User IDを渡して、その User が Group の Member か否かを判定します。
     *
     * Group Admin または Member の場合は true を、
     * Group Member でない場合は false を返します。
     *
     * またユーザーが利用停止中の場合は常に false が帰ります。
     *
     * @param user
     * @returns {*}
     */
    isMember: function(user) {
        const member = this._members.getMemberByUser(user);
        if(!member) {
            return null;
        }

        if(member.isSuspended()) {
            return false;
        }

        return true;
    },

    getMembers: function(options) {
        if(options && options.withSuspended) {
            return this._membersWithSuspended;
        }
        return this._members;
    },

    getMainLicense: function() {
        return this._licenses.find(
            l => _.contains(['balus', 'force'], l.getTarget()));
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/group.js